export default function CoffeeSection() {
  const coffeeProducts = [
    {
      name: "水洗處理",
      description: "乾淨透亮,果香明確,酸質精緻",
      detailedDescription: "水洗處理法是最經典的咖啡處理方式，透過發酵槽去除果膠，保留咖啡豆最純淨的風味。這種處理方式能夠突出咖啡豆本身的特性，呈現乾淨明亮的口感，酸質精緻而富有層次，是品嚐咖啡原始風味的最佳選擇。",
      image: "https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/e558855c4d1eb84bddd8e9ceb781ed98.jpeg",
      features: ["海拔1200公尺", "原始林栽培", "手工採收", "SL34品種"],
      farm: "F/B 馬的咖啡莊園",
      prices: [
        { type: "咖啡豆半磅227克", price: "NT$ 900" }
      ],
      processingDetails: "48小時發酵 → 清水洗淨 → 陰乾處理"
    },
    {
      name: "蜜處理",
      description: "甜感飽滿，滑順圓潤，果膠感強",
      detailedDescription: "蜜處理是介於水洗和日曬之間的處理方式，保留部分果膠進行乾燥，讓咖啡豆吸收果膠的甜味。這種處理方式創造出獨特的甜感和圓潤口感，果膠的天然糖分為咖啡帶來豐富的甜味層次，口感滑順而飽滿。",
      image: "https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/7d1c939e4f8479097cf2e0500040e9f6.jpeg",
      features: ["傳統工藝", "果膠發酵", "甜感豐富", "圓潤口感"],
      farm: "F/B 馬的咖啡莊園",
      prices: [
        { type: "咖啡豆半磅227克", price: "NT$ 1,000" }
      ],
      processingDetails: "去皮保留果膠 → 蜜處理發酵 → 緩慢乾燥"
    },
    {
      name: "日曬處理",
      description: "香氣奔放，熱帶果乾風味層次分明",
      detailedDescription: "日曬處理是最古老也最自然的咖啡處理方式，讓咖啡果實在陽光下自然乾燥，果肉的甜味完全滲透到咖啡豆中。這種處理方式創造出最豐富的風味層次，香氣奔放而濃郁，帶有明顯的熱帶水果和果乾風味。",
      image: "https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/536c506dc8378a49e2c59c9e3f271303.jpeg",
      features: ["自然日曬", "果香濃郁", "風味豐富", "層次分明"],
      farm: "F/B 馬的咖啡莊園",
      prices: [
        { type: "咖啡豆半磅227克", price: "NT$ 1,100" }
      ],
      processingDetails: "整果日曬 → 21天自然乾燥 → 去殼處理"
    }
  ];

  return (
    <section id="coffee" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* 標題區域 - 使用咖啡果實背景 */}
        <div 
          className="relative mb-16 py-20 rounded-3xl bg-cover bg-center bg-no-repeat overflow-hidden"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/c75dcc56ce5c237cd7ba8f83afeeb5c0.jpeg')`
          }}
        >
          {/* 背景遮罩層 - 確保文字清晰可見 */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/60"></div>
          
          {/* 內容區域 */}
          <div className="relative z-10 text-center text-white">
            {/* 處理方式標籤 */}
            <div className="mb-8">
              <div className="flex flex-wrap justify-center gap-4 mb-6">
                <span className="bg-gradient-to-r from-blue-500/90 to-blue-600/90 backdrop-blur-sm text-white px-6 py-3 rounded-full text-xl font-bold shadow-xl border border-white/20">
                  水洗處理
                </span>
                <span className="bg-gradient-to-r from-amber-500/90 to-amber-600/90 backdrop-blur-sm text-white px-6 py-3 rounded-full text-xl font-bold shadow-xl border border-white/20">
                  蜜處理
                </span>
                <span className="bg-gradient-to-r from-orange-500/90 to-orange-600/90 backdrop-blur-sm text-white px-6 py-3 rounded-full text-xl font-bold shadow-xl border border-white/20">
                  日曬處理
                </span>
              </div>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold mb-8 text-shadow-lg">
              我們的咖啡
            </h2>
            
            {/* 保險資訊 */}
            <div className="mb-8">
              <div className="flex items-center justify-center space-x-3 text-lg bg-green-500/90 backdrop-blur-sm text-white rounded-lg py-4 px-8 max-w-md mx-auto shadow-xl border border-white/20">
                <i className="ri-shield-check-line text-xl"></i>
                <span className="font-medium">本產品已投保責任險1000萬</span>
              </div>
            </div>
            
            <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8 text-shadow">
              每一顆咖啡豆都承載著馬爸爸馬媽媽的用心與堅持
            </p>
            
            {/* 咖啡描述文字 */}
            <div className="space-y-4 max-w-4xl mx-auto">
              <p className="text-lg md:text-xl font-medium italic text-amber-200 text-shadow">
                「從山裡誕生的香氣，叫作馬的咖啡。」
              </p>
              <p className="text-lg md:text-xl font-medium italic text-amber-200 text-shadow">
                「當咖啡懂得呼吸，那就是馬的味道。」
              </p>
              <p className="text-lg md:text-xl font-medium italic text-amber-200 text-shadow">
                「一口馬的咖啡，喚醒你對真實風味的想念。」
              </p>
            </div>
          </div>
        </div>
        
        <div className="space-y-16 mb-16">
          {coffeeProducts.map((product, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              {/* 圖片區域 - 放大 */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="relative">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-96 lg:h-[500px] object-contain bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl shadow-xl"
                  />
                  <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2">
                    <span className="text-amber-600 font-bold text-lg">{product.name}</span>
                  </div>
                </div>
              </div>

              {/* 內容區域 - 放大 */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-10">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-3xl lg:text-4xl font-bold text-gray-800">
                      {product.name}
                    </h3>
                  </div>
                  
                  <div className="flex items-center text-lg text-amber-600 mb-6">
                    <i className="ri-map-pin-line mr-2 text-xl"></i>
                    <span className="font-medium">{product.farm}</span>
                  </div>
                  
                  <p className="text-xl text-gray-600 mb-6 leading-relaxed font-medium">
                    {product.description}
                  </p>
                  
                  <p className="text-gray-700 mb-8 leading-relaxed text-lg">
                    {product.detailedDescription}
                  </p>

                  {/* 處理工藝流程 */}
                  <div className="mb-8 p-6 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl">
                    <h4 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                      <i className="ri-settings-3-line mr-2 text-amber-600"></i>
                      處理工藝
                    </h4>
                    <p className="text-gray-700 text-lg font-medium">{product.processingDetails}</p>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {product.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center text-lg text-amber-600">
                        <i className="ri-check-line mr-2 text-xl"></i>
                        <span className="font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  {/* 價格資訊 */}
                  <div className="border-t border-gray-200 pt-6 space-y-4">
                    {product.prices.map((priceItem, priceIndex) => (
                      <div key={priceIndex} className="flex items-center justify-between bg-gray-50 rounded-lg p-4">
                        <span className="text-lg text-gray-700 font-medium">{priceItem.type}</span>
                        <span className="text-2xl font-bold text-amber-600">{priceItem.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-amber-100 to-orange-100 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">
                咖啡品嚐體驗
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-amber-200 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-nose-line text-amber-700"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">香氣</h4>
                    <p className="text-gray-600">濃郁的山林花香，帶有淡淡的果香</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-amber-200 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-drop-line text-amber-700"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">口感</h4>
                    <p className="text-gray-600">醇厚順滑，酸甜平衡，回甘持久</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-amber-200 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-heart-line text-amber-700"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800">感受</h4>
                    <p className="text-gray-600">溫暖樸實，如山林般的寧靜與純淨</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/a5cb663643c0113f6f0fe9580232b6e9.jpeg"
                alt="咖啡品嚐體驗"
                className="w-full h-80 object-contain rounded-xl shadow-lg bg-white"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
